import { getHotelNowMoment } from '../../../utils/dateUtils';

export const CASH_COUNTER_SHIFTS = [
  { value: 'Morning', label: 'Morning', timeRange: '6:00 AM – 11:59 AM' },
  { value: 'Noon', label: 'Noon / Afternoon', timeRange: '12:00 PM – 4:59 PM' },
  { value: 'Evening', label: 'Evening', timeRange: '5:00 PM – 9:59 PM' },
  { value: 'Night', label: 'Night', timeRange: '10:00 PM – 5:59 AM' },
];

/** Suggest shift from hotel-local clock (falls back to browser if TZ missing). */
export function getSuggestedShift(now = getHotelNowMoment()) {
  const hour = now.hour();
  if (hour >= 6 && hour < 12) return 'Morning';
  if (hour >= 12 && hour < 17) return 'Noon';
  if (hour >= 17 && hour < 22) return 'Evening';
  return 'Night';
}

export function getShiftLabel(value) {
  const match = CASH_COUNTER_SHIFTS.find((s) => s.value === value);
  if (!match) return value || '—';
  return `${match.label} (${match.timeRange})`;
}
